import ignite from '../ignite';
import extractPageFromPath from '../page/extractPageFromPath.mjs';

const NavigationActions = {
  PAGE_REQUEST_STARTED: 'PAGE_REQUEST_STARTED',
  PAGE_REQUEST_COMPLETED: 'PAGE_REQUEST_COMPLETED',
  PAGE_REQUEST_FAILED: 'PAGE_REQUEST_FAILED'
};

const NavigationDirections = {
  BACK: 'BACK',
  FORWARD: 'FORWARD'
};

const pageRequestCompleted = (nextPage) => {
  return {
    type: NavigationActions.PAGE_REQUEST_COMPLETED,
    nextPage
  };
};

const pageRequestFailed = (error) => {
  return {
    type: NavigationActions.PAGE_REQUEST_FAILED,
    error
  };
};

const pageRequestStarted = reverse => {
  return {
    type: NavigationActions.PAGE_REQUEST_STARTED,
    direction: reverse ? NavigationDirections.BACK : NavigationDirections.FORWARD
  };
};

const goToNextPage = (reverse) => {
  return async (dispatch, getState) => {
    const currentPage = extractPageFromPath(getState().currentPage);
    try {
      dispatch( pageRequestStarted(reverse) );
      const pageResponse = await ignite.pageResolutionService.nextPage({
        page: currentPage,
        reverse
      });

      dispatch( pageRequestCompleted(pageResponse) );
    } catch (ex) {
      dispatch( pageRequestFailed(ex) );
    }
  };
};

const startGuide = (selectedPath) => {
  return async (dispatch) => {
    try {
      dispatch( pageRequestStarted() );
      const pageResponse = await ignite.pageResolutionService.nextPage({
        page: {
          'type': 'landing'
        },
        selectedPath
      });

      dispatch( pageRequestCompleted(pageResponse) );
    } catch (ex) {
      dispatch( pageRequestFailed(ex) );
    }
  };
};

export {
  goToNextPage,
  NavigationActions,
  NavigationDirections,
  startGuide
};
